import React from 'react'
import style from './eventSection.css'

export const EventSection = (props) => {
  const classOverride = style[props.classOverride] || ''
  return (
    <div id={props.sectionId} className={`${style.section} ${classOverride}`} tabIndex={-1}>
      { !props.loading && props.heading && <h3 className={style.heading}>{props.heading}</h3> }
      { props.children }
    </div>
  )
}
